// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root[data-v-3b83b018]{margin:0.5rem 0 0}.root a[data-v-3b83b018]{font-weight:bold}.root .affiliate__buy[data-v-3b83b018]{color:#323232 !important}.root .added[data-v-3b83b018]{color:#888;pointer-events:none;animation:fadein .7s forwards}.root .affiliate__with[data-v-3b83b018]{color:#2e51a2 !important}\n", ""]);
// Exports
module.exports = exports;
